import Model from "@viz-ui/models/model";

angular.module("acl.visualizer.model.model", []).factory("Model", function() {
  return Model;
});
